



































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Tips from '@/components/Tips.vue'

export interface CreateServiceFormValue {
    name: string;
    description: string;
    code: string;
    userName: string;
    url: string;
    file: File | undefined;
    useVoiceCommand: boolean;
    word: string | undefined;
    isBroadcast: boolean;
}

@Component({
    components: {
        Tips
    }
})
export default class CreateServiceForm extends Vue {
    @Prop({required: true})
    value!: CreateServiceFormValue 

    previewUrl: string | null = null
    tooLargeFile = false

    static valid(payload: CreateServiceFormValue) {
        const _validate = (target: string, min: number, max: number) => {
            if (min > target.length) return false
            if (target.length > max) return false
            return true
        }

        const result = 
            _validate(payload.name, 4, 20) && 
            _validate(payload.description, 4, 50) && 
            _validate(payload.userName, 4, 10) && 
            _validate(payload.code, 4, 10) && 
            (!payload.isBroadcast ? _validate(payload.url, 1, 1024) : true)

        if (!result) {
            return false
        }

        if (payload.file) {
            if (payload.file.size > 256_000) return false
        }

        return true
    }

    fireEvent(item: CreateServiceFormValue) {
        this.$emit("input", item)
    }

    get serviceName() {
        return this.value!.name
    }

    set serviceName(name: string) {
        const item = {...this.value!, name: name}
        this.fireEvent(item)
    }

    get serviceDescription() {
        return this.value!.description
    }

    set serviceDescription(description: string) {
        const item = {...this.value!, description: description}
        this.fireEvent(item)
    }

    get serviceCode() {
        return this.value.code
    }

    set serviceCode(code: string) {
        const item = {...this.value!, code: code}
        this.fireEvent(item)
    }

    get broadCasterName() {
        return this.value.userName
    }

    set broadCasterName(name: string) {
        const item = {...this.value!, userName: name}
        this.fireEvent(item)
    }

    get url() {
        return this.value.url
    }

    set url(url: string) {
        const item = {...this.value!, url: url}
        this.fireEvent(item)
    }

    get useVoiceCommand() {
        return this.value.useVoiceCommand
    }
    set useVoiceCommand(command: boolean) {
        const item = {...this.value!, useVoiceCommand: command}
        this.fireEvent(item)
    }

    get word() {
        if (this.value.word) {
            return this.value.word
        } else {
            return ""
        }
    }
    set word(command: string) {
        const item = {...this.value!, word: command}
        this.fireEvent(item)
    }

    get icon() {
        return this.value!.file
    }

    set icon(file: File | undefined) {
        if (file) {
            // check file
            if (file.size > (256 * 1024)) {
                this.tooLargeFile = true
                return
            }
            this.tooLargeFile = false
            this.previewUrl = window.URL.createObjectURL(file)
        } else {
            this.previewUrl = null
        }

        const item = {...this.value!, file: file}
        this.fireEvent(item)
    }

    removeFile() {
        this.icon = undefined
    }

    // Validation error messages
    get serviceDescriptionError(): string {
        if (this.value.description.length > 0 && this.value.description.length < 4) {
            return '4文字以上入力してください'
        }
        return ''
    }

    get serviceCodeError(): string {
        if (this.value.code.length > 0 && this.value.code.length < 4) {
            return '4文字以上入力してください'
        }
        return ''
    }

    get broadCasterNameError(): string {
        if (this.value.userName.length > 0 && this.value.userName.length < 4) {
            return '4文字以上入力してください'
        }
        return ''
    }

    get urlError(): string {
        if (!this.value.isBroadcast && this.value.url.length === 0) {
            return 'URLを入力してください'
        }
        return ''
    }
}
